import { offerApi } from "api/TenantSlug/Offer/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import FilterRequest = App.Http.Requests.FilterRequest;
import GetOffersRequest = App.Http.Requests.Offer.GetOffersRequest;
import OfferData = App.Data.OfferData;

interface Args {
    filter?: FilterRequest;
}

export const useOfferSelectOptions = ({ filter }: Args = {}) => {
    const queryParams: GetOffersRequest = {
        filter: {
            sort: "title",
            ...filter,
        },
    };

    return useSelectOptions<OfferData>({
        apiFunction: (payload) => offerApi.index(payload),
        dataKey: "offers",
        cacheKey: "offer-select",
        queryParams,
        mapToOption: (offer) => ({
            label: offer.title,
            value: offer.id,
        }),
    });
};
